import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Col, Row, } from "react-bootstrap";
import ReactTable from "react-table";
import debounce from "lodash/debounce";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import { minutesToHourAndMinutes } from "../../helpers/HelperFunctions";
import { hasPermission } from "../../helpers/Permissions";
import LogsService from "../../../services/LogsService";
import HandleError from "../../../services/HandleError";
import DeleteModal from "../../modals/DeleteModal";
import Materialicon from "../../helpers/Materialicon";

class TaskLogs extends Component {
	state = {
		taskLogToDelete: null,
		isDeleting: false,
		isLoadingTable: true,
		data: [],
		pages: 1,
	}
    
	getTaskLogs= (state) => {
		const { taskId } = this.props.match.params;
		const {pageSize, sorted, filtered, page } = state;
		const data = JSON.stringify({pageSize, sorted, filtered, page});
		this.setState({isLoadingTable: true});
		this.logsService.fetchTaskLogs(page+1, `data=${data}`, taskId).then((res) => {  
			this.setState({ 
				isLoadingTable:false, 
				data: res.data.data, 
				pages: res.data.last_page, 
				pageState: state
			});
		}).catch((err) => {
			this.setState({isLoadingTable:false});
			HandleError(err,this);
		});
	}
    
	taskLogToDelete = (tasklog) => {
		this.setState({taskLogToDelete : {name: "Log", id: tasklog.id}});
	}
	
	deleteTaskLog = () => {
		if(this.state.taskLogToDelete) {
			this.setState({ isDeleting: true });
			this.logsService.delete(this.state.taskLogToDelete.id).then((res) => {
				this.setState({ isDeleting: false });
				NotificationManager.success("Task Log deleted.", "Success!");
				this.props.history.goBack();
			}).catch((err) => {
				this.setState({ isDeleting: false });
				HandleError(err, this);
			}).then(() => {	
				this.getTaskLogs(this.state.pageState);		
				this.closeModal();
			});
		}
	}

	closeModal = () => {
		this.setState({
			taskLogToDelete: null,
			isDeleting: false,
		});
	}

	logsService = new LogsService(this);

	render() {
		const { data, isLoadingTable, pages } = this.state;
		const hasMyTasksPermission = hasPermission("task.myTasksDatatable");
    	return (
    		<div className="crud-page task-logs-page">
    			<div className="container-fluid">
    				<section className="actions">
    					<Row>
    						<Col md={6} sm={6} xs={12}>
    							<h2 className="page-title">All task logs</h2>
    						</Col>
    						<Col md={6} sm={6} xs={12}>
    							<Link to={hasMyTasksPermission ? "/tasks/my-tasks": "/tasks/all-tasks"} className="pull-right btn-add-big btn btn-default">
    								<Materialicon icon="keyboard_arrow_left" /> Back to Tasks
    							</Link>
    						</Col>
    					</Row>   
    				</section>
    				<div className="card card-top-border connection-card fadeInLoadUp">
    					<ReactTable
    						columns={[
    							{
    								Header: "Employee",
    								accessor: "logged_by",
    								Cell: row => (<div className="text-center"> {row.value} </div>)
								},
								{
    								Header: "Description",
    								accessor: "description",
    								Cell: row => (<div className="text-center"> {row.value} </div>)
    							},{
    								Header: "Time",
    								accessor: "time",
    								Cell(row) {
										const {hours, minutes} = minutesToHourAndMinutes(row.value);
										return (
											<div className="text-center"> 
												{ hours > 0 ? `${hours}h` : `${0}h`} { minutes > 0 ? ` and ${minutes}min` : null}
											</div>
										);
									}
    							},{
    								Header: "Logged At",
    								accessor: "logged_at",
    								Cell: row => (<div className="text-center"> {moment(row.value).format("DD-MM-YYYY")} </div>)
								},
								{
									Header: "Created at",
									accessor: "created_at",
									Cell: row => (<div className="text-center">{moment(row.value).format("DD-MM-YYYY HH:mm")}</div>),
									minWidth: 123
								}, {
    								Header: "Actions",
    								accessor: "id",
    								filterable: false,
    								sortable: false,
    								Cell: row => (
    									<div className="text-center">
    										<button title="Delete" onClick={() => this.taskLogToDelete(row.original)} className="btn-action material-icons btn-delete">delete</button>
    									</div>
    								)
    							}
    						]}
    						manual 
    						data={data}
    						pages={pages} 
    						loading={isLoadingTable}
    						onFetchData={ debounce(this.getTaskLogs, 400) } 
    						filterable
    						defaultSorted={[{ id: "created_at", desc: true }]}
    						defaultPageSize={20}
    						className="-highlight"
    					/>
    				</div>   
    			</div>
    			<DeleteModal
    				itemToDelete={this.state.taskLogToDelete}
    				deleteItem={this.deleteTaskLog}
    				isDeleting={this.state.isDeleting}
    				closeModal={this.closeModal}
    			/>
    		</div>
    	);
	}
}

TaskLogs.propTypes = {
	match: PropTypes.shape({
		params: PropTypes.shape({
			taskId: PropTypes.string.isRequired,
		}).isRequired,
	}).isRequired,
	history: PropTypes.shape({
		goBack: PropTypes.func.isRequired
	}).isRequired
};
export default TaskLogs;




// WEBPACK FOOTER //
// ./src/components/pages/tasks/TaskLogs.js